<template>
  <v-row class="align-stretch" justify="start" align-content="start">
    <v-col cols="12" sm="6" md="6" lg="3">
      <SingleValueChart
          :title="$t('components.TextToPayDashboard.TotalPaymentRequestsLabel')"
          :data="stats.total_payment_requests"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="3">
      <SingleValueChart
          :title="$t('components.TextToPayDashboard.TotalPaymentsLabel')"
          :data="stats.total_payments"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="3">
      <SingleValueChart
          :title="$t('components.TextToPayDashboard.AmountPaidLabel')"
          :data="amountReceived"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="3">
      <SingleValueChart
          :title="$t('components.TextToPayDashboard.AverageAmountPaidLabel')"
          :data="averageAmountReceived"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
  </v-row>
</template>

<script>
import SingleValueChart from '@/components/dashboard/charts/SingleValueChart';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export default {
  name: 'TextToPayKPIs',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    kpis: {
      type: Object,
      required: true
    },
    reportMode: {
      type: String,
      required: false,
      default: null
    }
  },
  data: () => ({
    stats: {
      total_payment_requests: 0,
      total_payments: 0,
      amount_paid: 0,
      average_amount_paid: 0
    },
    most_frequent_rating: {
      rating: 0,
      count: 0
    },
    average_rating: 0,
    total_positive_reviews: 0
  }),
  methods: {
    updateStats(data) {
      if (data) {
        this.stats = data;
      }
    }
  },
  computed: {
    amountReceived() {
      return currencyFormatter.format(this.stats.amount_paid);
    },
    averageAmountReceived() {
      return currencyFormatter.format(this.stats.average_amount_paid);
    }
  },
  watch: {
    kpis(value) {
      this.updateStats(value);
    }
  },
  components: {SingleValueChart}
}
</script>